fx.ns("shared.popups", class ExtractingPhotosPopup extends shared.popups.BasePersonPopup{
    
    constructor()
    {
        super();
        this.contentWidth = 400;
        this.contentHeight = 90;
        this._count = 0;

        this.closeOnClickBehind = false;
        this.showClose = false;
    }


    create()
    {
        super.create();
        this._title = new fx.components.Text({text:fx.text("Ajout de vos photos..."),className:"title center"});
        this.addChild(this._title);
    }

    onReady()
    {
        super.onReady();

        //this.on("photo-extracted", this._onPhotoExtracted, fx.service("MediasUploader").photoExtractor);
        //this.on("photo-extracted-finished", this._onPhotoExtractedFinished, fx.service("MediasUploader").photoExtractor);

        this.on("photo-extracted", this._onPhotoExtracted, fx.service("MediasUploader"));
        this.on("photo-extracted-finished", this._onPhotoExtractedFinished, fx.service("MediasUploader"));
    }



    _onPhotoExtracted(e)
    {
        if (e && e.detail && e.detail instanceof models.Photo)
        {
            this.personImage.addClass("center");
            this.personImage.cover = true;
            this.personImage.src = e.detail.thumb;
        }

        this._title.text = fx.text("Import de vos photos ($)", (++this._count) );
    }

    
    _onPhotoExtractedFinished()
    {
        this.close();
    }



});